/**
 * TelemetryCard — доставляемость пушей по платформам: отправлено, ошибки,
 * показано. Доля показов ниже ~50% подсвечена: прошивка режет фон,
 * протухшие токены или канал ушёл в лог-фолбэк.
 */

import {useState} from 'react';
import {useQuery} from '@tanstack/react-query';

import {telemetryQueryOptions} from '@services/system';
import {cn} from '@lib/utils';
import {formatNumber} from '@utils/format';

const DAYS = [7, 30] as const;

const pct = (v: number): string => `${Math.round(v * 100)}%`;

export const TelemetryCard = () => {
  const [days, setDays] = useState<number>(7);
  const {data} = useQuery(telemetryQueryOptions(days));
  const rows = data?.rows ?? [];

  return (
    <div className="rounded-[13px] border border-skr-line bg-card">
      <div className="flex items-center justify-between gap-2 px-4 py-3">
        <div>
          <div className="text-sm font-semibold">Пуш-уведомления</div>
          {data && (
            <div className="mt-0.5 text-[12px] text-muted-foreground">
              Отправлено {formatNumber(data.totalSent)} · ошибок {formatNumber(data.totalFailed)} ·
              показано {formatNumber(data.totalDisplayed)}
            </div>
          )}
        </div>
        <div className="flex rounded-[9px] border border-skr-line p-[2px]">
          {DAYS.map((d) => (
            <button
              key={d}
              onClick={() => setDays(d)}
              className={cn(
                'rounded-[7px] px-2.5 py-1 text-[12px] font-medium text-muted-foreground',
                days === d && 'bg-skr-head font-semibold text-foreground',
              )}
            >
              {d} дн
            </button>
          ))}
        </div>
      </div>
      {rows.length === 0 ? (
        <div className="border-t border-skr-hairline px-4 py-8 text-center text-[13px] text-muted-foreground">
          Пушей за период не было
        </div>
      ) : (
        <table className="w-full border-t border-skr-hairline text-[13px]">
          <thead>
            <tr className="text-left text-[12px] text-muted-foreground">
              <th className="px-4 py-2 font-medium">Платформа</th>
              <th className="px-3 py-2 text-right font-medium">Отправлено</th>
              <th className="px-3 py-2 text-right font-medium">Ошибки</th>
              <th className="px-3 py-2 text-right font-medium">Показано</th>
              <th className="px-4 py-2 text-right font-medium">Доля</th>
            </tr>
          </thead>
          <tbody className="font-mono">
            {rows.map((r) => (
              <tr key={`${r.platform}-${r.provider}`} className="border-t border-skr-hairline">
                <td className="px-4 py-2 font-sans">
                  {r.platform} <span className="text-skr-faint">· {r.provider}</span>
                </td>
                <td className="px-3 py-2 text-right">{formatNumber(r.sent)}</td>
                <td className="px-3 py-2 text-right">{formatNumber(r.failed)}</td>
                <td className="px-3 py-2 text-right">{formatNumber(r.displayed)}</td>
                <td
                  className={cn(
                    'px-4 py-2 text-right font-semibold',
                    r.sent > 0 && r.displayRate < 0.5 ? 'text-skr-danger' : 'text-skr-paid',
                  )}
                >
                  {r.sent > 0 ? pct(r.displayRate) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
